import React from 'react';
import { Box, Container } from '@mui/material';

// Default header image from public assets
const defaultHeaderImage = '/assets/images/header_banner3.png';

/**
 * PageLayout
 * - Provides the app-wide gradient background and a centered white card container
 * - Shows a full-width header image (within the card) with rounded corners
 * - Wraps page content inside a max-width Container for readability
 *
 * Props:
 * - children: React nodes to render inside the layout
 * - headerImage: optional custom image path; defaults to kiosk banner
 * - contentMaxWidth: MUI Container maxWidth for inner content (e.g., 'md' | 'lg' | 'xl')
 * - showHeaderImage: whether to display the header image (default: true)
 * - contentPadding: sx value for inner padding (default uses sensible spacing)
 */
const PageLayout = ({
  children,
  headerImage = defaultHeaderImage,
  contentMaxWidth = 'md',
  showHeaderImage = true,
  contentPadding = { xs: 3, sm: 4 },
}) => {
  return (
    <Box sx={{ width: '100%', minHeight: '100vh', pt: '50px', pb: '50px', boxSizing: 'border-box', background: 'linear-gradient(135deg, #E3F2FD 0%, #F3E5F5 50%, #FFF8E1 100%)' }}>
      <Box sx={{ maxWidth: 1400, mx: 'auto', px: { xs: 2, sm: 4 }, pt: showHeaderImage ? 1 : { xs: 1, sm: 2 }, pb: { xs: 2, sm: 3 }, bgcolor: 'rgba(255,255,255,0.92)', borderRadius: 3, boxShadow: '0 10px 30px rgba(0,0,0,0.08)' }}>
        {showHeaderImage && (
          <Box
            component="img"
            src={headerImage}
            alt="Page Header"
            sx={{
              width: '80%',
              maxHeight: '300px',
              objectFit: 'cover',
              display: 'block',
              marginBottom: 4,
              mx: 'auto',
              borderRadius: 3,
            }}
          />
        )}

        <Container maxWidth={contentMaxWidth} sx={{ px: { xs: 0, sm: 2 }, py: contentPadding }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default PageLayout;
